import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "cryptoWIthdrawContainer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "textTitle" }
const _hoisted_4 = { class: "crypto_field" }
const _hoisted_5 = { class: "label_margin" }
const _hoisted_6 = { class: "pin-input-row" }
const _hoisted_7 = ["onUpdate:modelValue", "readonly", "onFocus", "onInput", "onKeydown"]
const _hoisted_8 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_9 = { class: "crypto_field" }
const _hoisted_10 = { class: "label_margin" }
const _hoisted_11 = { class: "pin-input-row" }
const _hoisted_12 = ["onUpdate:modelValue", "readonly", "onFocus", "onInput", "onKeydown"]
const _hoisted_13 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_14 = { class: "btn_container" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "crypto_field" }
const _hoisted_17 = { class: "right_Icons" }
const _hoisted_18 = { class: "crypto_field" }
const _hoisted_19 = { class: "crypto_field" }
const _hoisted_20 = { class: "crypto_field" }
const _hoisted_21 = { class: "btn_container" }

import { formatCurrency } from '@/utils/commonFunction';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import MainButton from '../components/common/mainButton.vue';
import AddressBookPopup from './components/addressBookPopup.vue';
import NetworkSelectPopup from './components/networkSelectPopup.vue';
import { callNetworkOptions, callWithdraw, useScanner } from '@/view/withdraw/supportScript';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { checkConfirmPasswordValidation, checkWithdrawPasswordValidation, updateWithdrawPassword } from '@/view/profile/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'cryptoWithdraw',
  setup(__props) {

const userStore = useUserStore();
const address = ref('');
const network = ref('');
const securityPassword = ref('');
const withdrawalAmount = ref('');
const withdrawMin = ref(0);
const isSuccess = ref(false);
const statusRef = ref();
const loadingRef = ref();
const toastContent = ref('');
const addressBookPopupRef = ref();
const networkPopupRef = ref();
const networkList = ref([]);
const selectedNetwork = ref<any>({});
const uId = ref(userStore.id);

const newPasswordArray = ref(['', '', '', '', '', '']);
const confirmPasswordArray = ref(['', '', '', '', '', '']);
const newInputsRef = ref<HTMLInputElement[]>([]);
const confirmInputsRef = ref<HTMLInputElement[]>([]);

const newPassStr = computed(() => newPasswordArray.value.join(''));
const confirmPassStr = computed(() => confirmPasswordArray.value.join(''));

const newActiveIndex = computed(() => {
    const idx = newPasswordArray.value.findIndex((v) => v === '');
    return idx === -1 ? newPasswordArray.value.length - 1 : idx;
});

const confirmActiveIndex = computed(() => {
    const idx = confirmPasswordArray.value.findIndex((v) => v === '');
    return idx === -1 ? confirmPasswordArray.value.length - 1 : idx;
});

const passwordValidationNotice = ref(false);
const confirmPasswordValidationNotice = ref(false);

const isSubmitBtnActivated = computed(() => {
    return (
        newPassStr.value.length === 6 &&
        confirmPassStr.value.length === 6 &&
        !passwordValidationNotice.value &&
        !confirmPasswordValidationNotice.value &&
        newPassStr.value === confirmPassStr.value
    );
});

const handleKeyPress = (e: KeyboardEvent) => {
    const char = String.fromCharCode(e.which);
    if (!/[0-9]/.test(char)) {
        e.preventDefault();
    }
};

const handlePinInput = (e: any, index: number, type: 'new' | 'confirm') => {
    const dataArr = type === 'new' ? newPasswordArray.value : confirmPasswordArray.value;
    const activeIndex = type === 'new' ? newActiveIndex.value : confirmActiveIndex.value;
    const inputs = type === 'new' ? newInputsRef.value : confirmInputsRef.value;

    if (index !== activeIndex) {
        e.target.value = dataArr[index] || '';
        inputs[activeIndex]?.focus();
        return;
    }

    const rawValue = e.target.value;
    const digitsOnly = String(rawValue).replace(/\D/g, '');

    if (!digitsOnly) {
        dataArr[index] = '';
        e.target.value = '';
        return;
    }

    const digit = digitsOnly.slice(-1);

    dataArr[index] = digit;
    e.target.value = digit;

    if (index < dataArr.length - 1) {
        inputs[index + 1]?.focus();
    }
};

const handlePinBackspace = (e: KeyboardEvent, index: number, type: 'new' | 'confirm') => {
    if (e.key !== 'Backspace') return;

    const inputs = type === 'new' ? newInputsRef.value : confirmInputsRef.value;
    const dataArr = type === 'new' ? newPasswordArray.value : confirmPasswordArray.value;
    const activeIndex = type === 'new' ? newActiveIndex.value : confirmActiveIndex.value;

    if (index !== activeIndex) {
        e.preventDefault();
        inputs[activeIndex]?.focus();
        return;
    }

    if (dataArr[index]) {
        dataArr[index] = '';
        return;
    }

    if (index > 0) {
        dataArr[index - 1] = '';
        inputs[index - 1]?.focus();
    }
};

const handleUpdatePassword = () => {
    updateWithdrawPassword('', newPassStr.value, ref(false), toastContent, isSuccess, statusRef);
};

const buttonActive = computed(() => {
    return (
        address.value.trim() !== '' &&
        network.value.trim() !== '' &&
        securityPassword.value.trim() !== '' &&
        withdrawalAmount.value !== '' &&
        Number(withdrawalAmount.value) > 0
    );
});

const { showScanner, startScanner, stopScanner } = useScanner();

const handleStartScan = () => {
    startScanner('reader', (result) => {
        address.value = result;
    });
};

const showAddressPopup = () => addressBookPopupRef.value.openPopup();
const showNetworkPopup = () => networkPopupRef.value.openPopup();

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open();
};
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open();
};

const confirmWithdraw = async () => {
    loadingRef.value.open();
    const { data } = await callWithdraw(address.value, uId.value, withdrawalAmount.value, selectedNetwork.value.id, securityPassword.value);
    loadingRef.value.close();
    if (data.code == 200) {
        showSuccess(data.msg);
    } else {
        showError(data);
    }
};

const getNetworkOption = async (addr?: string) => {
    if (addr) address.value = addr;
    const { network_list } = await callNetworkOptions(address.value);
    networkList.value = network_list;
};

const setSelecteddNetwork = (networkData: any) => {
    selectedNetwork.value = networkData;
    network.value = networkData?.channelName;
    networkPopupRef.value.closePopup();
};

watch(() => address.value, () => {
    getNetworkOption();
    network.value = '';
});

// Watch the generated strings to trigger validation notices
watch(newPassStr, (val) => {
    checkWithdrawPasswordValidation(val, passwordValidationNotice);
});

watch(confirmPassStr, (val) => {
    checkConfirmPasswordValidation(val, ref(confirmPassStr.value), ref(newPassStr.value), confirmPasswordValidationNotice);
});

onUnmounted(() => stopScanner());
onMounted(() => getNetworkOption());

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(userStore).withdrawPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('profile.withdrawalPassword')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('withdraw.securityPassword')), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newPasswordArray.value, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 'new-' + index,
                  ref_for: true,
                  ref_key: "newInputsRef",
                  ref: newInputsRef,
                  "onUpdate:modelValue": ($event: any) => ((newPasswordArray.value[index]) = $event),
                  readonly: index !== newActiveIndex.value,
                  type: "password",
                  pattern: "[0-9]*",
                  inputmode: "numeric",
                  maxlength: "1",
                  class: "pin-box",
                  onFocus: (e) => index === newActiveIndex.value ? null : e.target.blur(),
                  onKeypress: handleKeyPress,
                  onInput: ($event: any) => (handlePinInput($event, index, 'new')),
                  onKeydown: _withKeys(($event: any) => (handlePinBackspace($event, index, 'new')), ["delete"])
                }, null, 40, _hoisted_7)), [
                  [_vModelText, newPasswordArray.value[index]]
                ])
              }), 128))
            ]),
            (passwordValidationNotice.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('loginRegister.passwordForamtNew')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('profile.cnofirmNewPassword')), 1),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmPasswordArray.value, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 'confirm-' + index,
                  ref_for: true,
                  ref_key: "confirmInputsRef",
                  ref: confirmInputsRef,
                  "onUpdate:modelValue": ($event: any) => ((confirmPasswordArray.value[index]) = $event),
                  readonly: index !== confirmActiveIndex.value,
                  type: "password",
                  pattern: "[0-9]*",
                  inputmode: "numeric",
                  maxlength: "1",
                  class: "pin-box",
                  onFocus: (e) => index === confirmActiveIndex.value ? null : e.target.blur(),
                  onKeypress: handleKeyPress,
                  onInput: ($event: any) => (handlePinInput($event, index, 'confirm')),
                  onKeydown: _withKeys(($event: any) => (handlePinBackspace($event, index, 'confirm')), ["delete"])
                }, null, 40, _hoisted_12)), [
                  [_vModelText, confirmPasswordArray.value[index]]
                ])
              }), 128))
            ]),
            (confirmPassStr.value && newPassStr.value && confirmPassStr.value !== newPassStr.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('loginRegister.differentPassword')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(MainButton, {
              title: _ctx.$t('profile.save'),
              activeStatus: isSubmitBtnActivated.value,
              onClick: handleUpdatePassword,
              radius: '8px',
              "btn-padding": '28px',
              forceGradientWhenDisabled: true
            }, null, 8, ["title", "activeStatus"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.address')), 1),
            _createVNode(_component_van_field, {
              modelValue: address.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address).value = $event)),
              placeholder: _ctx.$t('withdraw.address')
            }, {
              "right-icon": _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_van_icon, {
                    name: "user-circle-o",
                    color: "#FFF",
                    size: "22",
                    style: {"padding-right":"15px"},
                    onClick: showAddressPopup
                  }),
                  _createVNode(_component_van_icon, {
                    name: "scan",
                    size: "22",
                    color: "#FFF",
                    onClick: handleStartScan
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.network')), 1),
            _createElementVNode("div", {
              class: "networkField",
              onClick: showNetworkPopup
            }, _toDisplayString(network.value ? network.value : _ctx.$t('withdraw.network')), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.securityPassword')), 1),
            _createVNode(_component_van_field, {
              modelValue: securityPassword.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((securityPassword).value = $event)),
              type: "password",
              placeholder: _ctx.$t('withdraw.securityPassword')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.withdrawalAmount')), 1),
            _createVNode(_component_van_field, {
              modelValue: withdrawalAmount.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((withdrawalAmount).value = $event)),
              type: "number",
              placeholder: _ctx.$t('withdraw.withdrawalMinAmount', { value: withdrawMin.value })
            }, {
              "right-icon": _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "rightText" }, [
                  _createTextVNode(" USDT "),
                  _createElementVNode("span", null, "Max")
                ], -1)
              ])),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(MainButton, {
              title: _ctx.$t('common.retirarAgora'),
              activeStatus: buttonActive.value,
              onClick: confirmWithdraw,
              radius: '8px',
              "btn-padding": '28px',
              forceGradientWhenDisabled: true
            }, null, 8, ["title", "activeStatus"])
          ])
        ])),
    _createVNode(_component_van_popup, {
      show: _unref(showScanner),
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showScanner) ? (showScanner).value = $event : null)),
      class: "transparent-scanner-popup",
      onClosed: _unref(stopScanner),
      "overlay-style": { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "scanner-wrapper" }, [
          _createElementVNode("div", { id: "reader" })
        ], -1)
      ])),
      _: 1
    }, 8, ["show", "onClosed"]),
    _createVNode(AddressBookPopup, {
      ref_key: "addressBookPopupRef",
      ref: addressBookPopupRef
    }, null, 512),
    _createVNode(NetworkSelectPopup, {
      ref_key: "networkPopupRef",
      ref: networkPopupRef,
      networkList: networkList.value,
      onSelectNetwork: setSelecteddNetwork
    }, null, 8, ["networkList"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ]))
}
}

})